import styles from './financial-dd-misses.module.scss';
import parse from 'html-react-parser';
import Image from 'next/image';
import { techDueDiligenceState } from '../../tech-due-diligence.state';

const FinancialDDMisses = () => {
  const { title, cards } = techDueDiligenceState.financialDDMisses;

  return (
    <section className={styles.section}>
      <div className={styles.section__head}>
        <h2 className={styles.section__head__title}>{parse(title)}</h2>
      </div>
      <div className={styles.section__cards}>
        {cards?.map((card: any, key: any) => (
          <div key={key} className={`${styles.section__card} ${card.linkUrl ? styles.section__card_link : ''}`}>
            {card.iconUrl ? (
              <div className={styles.section__card_head}>
                <div className={styles.section__card_head__image}>
                  <Image
                    src={card.iconUrl}
                    alt={card.title}
                    layout="fixed"
                    objectFit="contain"
                    width={36}
                    height={36}
                  />
                </div>
                <h4 className={styles.section__subtitle}>{card.title}</h4>
              </div>
            ) : null}
            {!card.iconUrl && card.order ? (
              <div className={styles.section__card_head_order}>
                <div className={styles.section__card_head_order__value}>{card.order}</div>
                <h4 className={styles.section__card_head_order__subtitle}>{card.title}</h4>
              </div>
            ) : null}
            <p className={styles.section__text}>{card.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FinancialDDMisses;
